module.exports = __webpack_public_path__ + "media/DataViz_high.2e5e5789.mp4";